import { render, staticRenderFns } from "./LogoExplicae.vue?vue&type=template&id=0f68e94a"
import script from "./LogoExplicae.vue?vue&type=script&lang=ts"
export * from "./LogoExplicae.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports